module.exports = __webpack_public_path__ + "static/img/category_60.0c574a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/category_60.png
// module id = UjXp
// module chunks = 0